module.exports = __webpack_public_path__ + "static/media/Order.d58ac9f6.svg";